import React from 'react'
import starCircle from '../assets/img/star-circle.svg'
import starIcon from '../assets/img/star.svg'
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


export const MinimalCost = () => {
    const options = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      bar: {
        borderRadius: 4,
         borderSkipped: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
        font: {
          size: 20,
        },
        color: '#FFFFFFB2',
      },
      },
      y: {
        min: 0,
        max: 1000,
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

 const dataRed= {
  labels: ["Ставка", "Ставка"],
  datasets: [
    {
      label: "Создатель",
      data: [500, 500],
      backgroundColor: (context) => {
        const chart = context.chart;
        const {ctx, chartArea} = chart;
        
        if (!chartArea) {
          return null;
        }
        
        const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
        gradient.addColorStop(0, '#BD3838');   
        gradient.addColorStop(1, '#500808');
        return gradient;
      },
      borderWidth: 1,
    },
  ],
};

const dataBlue = {
  labels: ["Ставка", "Ставка"],
  datasets: [
    {
      label: "Создатель",
      data: [800, 800],
      backgroundColor: (context) => {
        const chart = context.chart;
        const {ctx, chartArea} = chart;
        
        if (!chartArea) {
          return null;
        }
        
        const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
        gradient.addColorStop(0, '#676FFF');   
        gradient.addColorStop(1, '#022C81');
        return gradient;
      },
      borderWidth: 1,
    },
  ],
};

const dataPurple = {
  labels: ["Ставка", "Ставка"],
  datasets: [
    {
      label: "Создатель",
      data: [1000, 1000],
      backgroundColor: (context) => {
        const chart = context.chart;
        const {ctx, chartArea} = chart;
        
        if (!chartArea) {
          return null;
        }
        
        const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
        gradient.addColorStop(0, '#3B03B2');   
        gradient.addColorStop(1, '#20045D');
        return gradient;
      },
      borderWidth: 1,
    },
  ],
};

  return (
    <div id="minimal-cost">
        <div className="container">
            <div className="minimal-cost">
                <div className="heading">
                    <h1>Минимальная стоимость</h1>
                    <div className="big-grey">Наслаждайтесь ведущей конкурентоспособной комиссией на рынке , всего от 0%</div>
                </div>
                <div className="cards">
                    <div className="card">
                        <div className="min-cost-title"><img src={starCircle} alt="" /> Будущие</div>
                        <div className="min-cost-boxes">
                            <div className="min-cost-box">
                                <div className="min-cost-box-txt">
                                    <span>Создатель</span>
                                    <div className="min-cost-perc">0 %</div>
                                </div>
                                <div className="min-cost-stats">
                                    <Bar options={options} data={dataRed}/>
                                </div>
                            </div>
                                <div className="min-cost-line"></div>
                                <div className="min-cost-box">
                                    <div className="min-cost-box-txt">
                                        <span>Искатель</span>
                                        <div className="min-cost-perc">0,02 %</div>
                                    </div>
                                    <div className="min-cost-stats">
                                       <Bar options={options} data={dataBlue}/>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="min-cost-title"><img src={starIcon} alt="" /> Пятно</div>
                        <div className="min-cost-boxes">
                            <div className="min-cost-box">
                                <div className="min-cost-box-txt">
                                    <span>Создатель</span>
                                    <div className="min-cost-perc">0 %</div>
                                </div>
                                <div className="min-cost-stats">
                                    <Bar options={options} data={dataPurple}/>
                                </div>
                            </div>
                                <div className="min-cost-line"></div>
                                <div className="min-cost-box">
                                    <div className="min-cost-box-txt">
                                        <span>Создатель</span>
                                        <div className="min-cost-perc">0 %</div>
                                    </div>
                                    <div className="min-cost-stats">
                                        <Bar options={options} data={dataPurple}/>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
